import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, NavLink, useNavigate } from 'react-router-dom';
import { Typography, Container } from '@mui/material';

import axios from "axios";
import config from "../../config";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';

const YardMaster = () => {

  const navigate = useNavigate();

  const [allYards, setAllYards] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {

    const authToken = localStorage.getItem('authToken');

    if (authToken === null) {

      navigate('/login');

    }

  }, [navigate]);

  useEffect(() => {

    axios
      .get(`${config.API_BASE_URL}getAllYardMaster`)
      .then((result) => {

        if (result.data.status) {

          setAllYards(result.data.data);

        }

      })
      .catch((error) => {

        console.log(error);

      });

  }, []);

  const handlePageChange = (newPage) => {

    setCurrentPage(newPage);

  };

  const handleSearchChange = (event) => {

    setSearchQuery(event.target.value);

    setCurrentPage(1);

  };

  const filteredItems = allYards.filter(item =>

    item.yard_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||

    item.yard_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||

    item.created_by_name?.toLowerCase().includes(searchQuery.toLowerCase())

  );

  const startIndex = (currentPage - 1) * config.HUNDREAD_PER_PAGE;

  const endIndex = startIndex + config.HUNDREAD_PER_PAGE;

  const paginatedItems = filteredItems.slice(startIndex, endIndex);

  const totalPages = Math.ceil(filteredItems.length / config.HUNDREAD_PER_PAGE);

  return (
    <>

      <Helmet>
        <title> Yard Master | Ckers </title>
      </Helmet>

      <Container>

        <div className="d-flex align-items-center justify-content-between mb-0">

          <span>&nbsp;</span>

          <RouterLink
            to='/dashboard/create-yard-master'
            className='add-btn btn-primary btn'
          >
            <i className="bi bi-plus">&nbsp;</i>
            Add Yard
          </RouterLink>

        </div>

        <div id='main-wrap' className='mmt-7'>

          <div className='row justify-content-between'>

            <div className='col-md-8'>

              <Typography className='line-initial' variant="h4" sx={{ mb: 0 }}>
                Yard Master
              </Typography>

            </div>

            <div className='col-md-4 pe-0 ps-lg-5'>

              <div className="form-group">

                <label htmlFor="search">

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    id="search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />

                </label>

              </div>

            </div>

          </div>

          <div className='table-wrap'>

            <table className="table table-hover">

              <thead>

                <tr>

                  <th>Yard ID</th>

                  <th>Yard Name</th>

                  <th>Yard Address</th>

                  <th>Status</th>

                  <th>Created By</th>

                  <th>Created On</th>

                  <th>Action</th>

                </tr>

              </thead>

              <tbody>

                {paginatedItems.length > 0 ? (

                  paginatedItems.map((item, index) => (

                    <tr key={index}>

                      <td>{item.yard_id}</td>

                      <td>{item.yard_name}</td>

                      <td>{item.yard_address}</td>

                      <td>

                        <span
                          className={
                            item.status === '1'
                              ? "badge text-bg-success text-white"
                              : "badge text-bg-danger text-white"
                          }
                        >
                          {item.status === '1' ? 'Active' : 'Inactive'}
                        </span>

                      </td>

                      <td>{item.created_by_name}</td>

                    <td>
                      {
                        item.created_at
                          ? `${new Date(item.created_at)
                              .toLocaleDateString('en-GB')
                              .replace(/\//g, '-')} ${new Date(item.created_at)
                              .toLocaleTimeString('en-GB')}`
                          : '-'
                      }
                    </td>

                      <td>

                        <div
                          className="btn-group dropstart"
                          title="Edit"
                        >

                          <NavLink
                            to={`/dashboard/create-edit-yard-master/${btoa(item.id)}`}
                          >

                            <i
                              className="bi bi-pen"
                              style={{ color: "black" }}
                            />

                          </NavLink>

                        </div>

                      </td>

                    </tr>

                  ))

                ) : (

                  <tr>

                    <td colSpan="7" className='text-center'>
                      No Data Found
                    </td>

                  </tr>

                )}

              </tbody>

            </table>

          </div>

          <div>

            <nav className='mb-1'>

              <ul className="pagination pagination-md justify-content-end">

                {Array.from(
                  { length: totalPages },
                  (_, index) => index + 1
                ).map(page => (

                  <li className="page-item" key={page}>

                    <button
                      onClick={() => handlePageChange(page)}
                      disabled={currentPage === page}
                      className="page-link"
                    >
                      {page}
                    </button>

                  </li>

                ))}

              </ul>

            </nav>

          </div>

        </div>

      </Container>

    </>
  );
}

export default YardMaster;